import { AnyAction, Reducer } from 'redux';
import {
  StateType,
  PaymentDetailsRequestAction,
  PaymentDetailsFailureAction,
  PaymentDetailsSuccessAction,
} from './types';

import {
  PAYMENT_DETAILS_FAILURE,
  PAYMENT_DETAILS_REQUEST,
  PAYMENT_DETAILS_SUCCESS,
} from './action-types';

const initialState: StateType = {
  loading: false,
  error: false,
  data: {},
};

const matchPaymentDetailsRequest = (action: AnyAction): action is PaymentDetailsRequestAction =>
  action.type === PAYMENT_DETAILS_REQUEST;
const matchPaymentDetailsSuccess = (action: AnyAction): action is PaymentDetailsSuccessAction =>
  action.type === PAYMENT_DETAILS_SUCCESS;
const matchPaymentDetailsFailure = (action: AnyAction): action is PaymentDetailsFailureAction =>
  action.type === PAYMENT_DETAILS_FAILURE;

export const reducers: Reducer<StateType, AnyAction> = (state = initialState, action) => {
  if (matchPaymentDetailsRequest(action)) {
    return {
      ...state,
      loading: true,
      error: false,
      data: {},
    };
  }

  if (matchPaymentDetailsSuccess(action)) {
    return {
      ...state,
      loading: false,
      error: false,
      data: { ...action.payload },
    };
  }

  if (matchPaymentDetailsFailure(action)) {
    return {
      ...state,
      loading: false,
      error: true,
      data: {},
    };
  }

  return state;
};
